import store from '../actions/store';

export const nuevaPublicacion = () => {
    let state = store.getState();

    return {
        idSeller: state.general.idSeller,
        observacion: "",
        titulo: "",
        ean: "",
        skuMarket: '',
        precioLista: null,
        precioPromocional: null,
        linkYoutube: "",
        descripcionAmpliada: "",
        tipoEntrega: [1],
        envioGratis: true,
        dimensiones: [{
            alto: 0,
            ancho: 0,
            profundidad: 0,
            peso: 0,
        }],
        alto: 1.0,
        ancho: 1.0,
        profundidad: 1.0,
        peso: 1.0,
        categoria: 0,
        marca: 0,
        skuSeller: "",
        stock: null,
        estado: "pendiente_activacion",
        imagenes: [],
        idTipoPublicacion: null,
        fechaUltimaModificacion: "",
        idMotivoRevision: 0,
        envioPropio: false,
        garantiaExtActiva: false,
        garantiaFabrica: 0,
        codigoElegibilidad: ""
    }
}

export const mapPublicacion = (p) => {
    let publicacion = null;
    let tipoEntrega = [];
    if (p != undefined) {

        p.tipoEntrega.map((tipo) => tipoEntrega.push(tipo.codigo));

        publicacion = {
            idPublicacion: p.idPublicacion,
            idSeller: p.idSeller,
            observacion: p.observacion,
            titulo: p.titulo,
            skuMarket: p.skuMarket,
            ean: p.ean,
            precioLista: currencyFormatInMapping(p.precioLista),
            precioPromocional: currencyFormatInMapping(p.precioPromocional),
            linkYoutube: p.linkYoutube,
            descripcionAmpliada: p.descripcionAmpliada,
            tipoEntrega: tipoEntrega,
            envioGratis: p.envioGratis,
            dimensiones: p.dimensiones,
            categoria: p.categoria.codigo,
            marca: p.marca.codigo,
            skuSeller: p.skuSeller,
            stock: p.stock,
            estado: p.estado,
            imagenes: p.imagenes,
            idTipoPublicacion: p.tipoPublicacion != null ? p.tipoPublicacion.codigo : 0,
            fechaUltimaModificacion: p.fechaUltimaModificacion,
            idMotivoRevision: p.motivoRevision.codigo,
            observacionesRevision: p.motivoRevision.observacionesRevision,
            nombreSeller: p.seller.descripcion,
            tipoPublicacion: p.tipoPublicacion,
            tieneRebate: p.tieneRebate,
            envioPropio: p.envioPropio,
            garantiaExtActiva: p.garantiaExtActiva,
            garantiaFabrica: p.garantiaFabrica,
            codigoElegibilidad: p.codigoElegibilidad,
            idUser: p.idUser,
        }
    }
    return publicacion;
}

// MOVER A LA CARPETA UTILITIES YA QUE NO SE REUTILIZA SOLO EN PUBLICACIONES
export const currencyFormat = (num) => {
    if (typeof num !== "string") num = num.toString();
    if (isNaN(num) || num === "") return "";

    let lastCharacterIsNotComma = (num[num.length - 1] !== ",") ? true : false;

    if (lastCharacterIsNotComma) {

        let dotsRemovedNumber = num.replace(/\./g, "");
        let commasReplacedNumber = dotsRemovedNumber.replace(/\,/g, ".");
        let floatNumber = parseFloat(commasReplacedNumber);
        let formattedNumber = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(floatNumber);
        return formattedNumber;
    } else {
        return num;
    }
}

export const currencyFormatInMapping = (num) => {
    if (typeof num === "string") num = new Number(num);

    let formattedNumber = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
    return formattedNumber;
}

export const formatCurrencyToNumber = (num) => {
    let numIsEmpty = (num == "" || num == null);
    if (numIsEmpty) return null;
    if (typeof num !== "string") num = num.toString();

    let dotsRemovedNumber = num.replace(/\./g, "");
    let commasReplacedNumber = dotsRemovedNumber.replace(/\,/g, ".");
    let formattedNumber = new Number(commasReplacedNumber);
    return formattedNumber;
}